import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { staffDetails, IStaffResponse, userPermissions, IStaffObject} from '../services/staff.model';
@Injectable({
  providedIn: 'root',
})
export class StaffService {
  constructor(private _http: HttpClient, private _header: HttpHeadersService) {}

  public getList(facilityId: string): Observable<IStaffResponse> {
    const headers = this._header.bearerHttpAuthorizationHeader();
    const result = this._http.get(`${environment.servicePath}/manager/get_manager_list?facilityId=${facilityId}`, {
      headers,
    });
    return result as Observable<IStaffResponse>;
  }

  public saveStaff(data: staffDetails): Observable<any> {
    let headers = this._header.bearerHttpAuthorizationHeader();
    return this._http.post(environment.servicePath + '/manager/register_manager', data, { headers });
  }

  public resendInvite(data: { facilityId: String; email: String }): Observable<any> {
    let headers = this._header.bearerHttpAuthorizationHeader();
    return this._http.post(environment.servicePath + '/manager/resend_email', data, { headers });
  }
  public saveUserPermission(data:userPermissions): Observable<any> {
    let headers = this._header.bearerHttpAuthorizationHeader();
    return this._http.post(environment.servicePath + '/user_rights/save', data,{ headers });
  }
  public deleteStaff(data: { facilityId: string; managerId: string; }): Observable<any> {
    let headers = this._header.bearerHttpAuthorizationHeader();
    return this._http.post(environment.servicePath + '/manager/delink_manager', data,{ headers });
  }

  public getStaff(facilityId: string, userId: string) : Promise<IStaffObject | any> {
    const headers = this._header.bearerHttpAuthorizationHeader();
    return this._http.get(`${environment.servicePath}/manager/by_facility?facilityId=${facilityId}&userId=${userId}`, { headers }).toPromise();
  }
}
